import {Theme} from "@mui/material";
import {SxType} from "@baseTypes/sx/sxTypes";
import {ITEM_SYNC} from "@containers/singleVoyage/voyageTemplates/sync/theme";

export const sx: SxType = {
	root: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: '2px',
		p: '8px 10px 8px 4px',
		cursor: 'pointer',
		...ITEM_SYNC,
	},
	checkbox: {
		p: '4px',
	},
	body: {
		flex: 1,
		minWidth: 0,
		gap: '2px',
	},
	line: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'baseline',
		gap: '8px',
	},
	day: {
		fontSize: '14px',
		fontWeight: 600,
	},
	time: {
		fontSize: '13px',
		color: 'text.secondary',
		whiteSpace: 'nowrap',
	},
	plate: {
		fontSize: '13px',
		color: 'text.secondary',
	},
	status: {
		display: 'inline-flex',
		alignItems: 'center',
		alignSelf: 'flex-start',
		gap: '6px',
		mt: '4px',
		fontSize: '12px',
		fontWeight: 600,
	},
	dot: {
		width: '8px',
		height: '8px',
		borderRadius: '50%',
		bgcolor: 'currentColor',
	},
	ok: {
		color: (theme: Theme) => theme.palette.mode === 'dark' ? '#81C784' : '#2E7D32',
	},
	warn: {
		color: (theme: Theme) => theme.palette.mode === 'dark' ? '#FFB74D' : '#B95C00',
	},
	fail: {
		color: (theme: Theme) => theme.palette.mode === 'dark' ? '#E57373' : '#C62828',
	},
}
